import React from 'react';

export class LegalDoc extends React.Component {
  render() {
    return <main class="content">
      <h1>{this.props.title}</h1>
      <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
    </main>;
  }
}